module.exports = __webpack_public_path__ + "media/10d.d3e358c9.mp4";